import m from "../../geodata/es2015/portugalRegionsLow";
window.am4geodata_portugalRegionsLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/portugalRegionsLow.js
// module id = null
// module chunks = 